import { Component } from "react";

import { BTLocalStorage } from "types/btStorage";

import { withErrorBoundary } from "commonComponents/helpers/ErrorBoundary/ErrorBoundary";
import GeneralWarningBanner from "commonComponents/utilities/HeaderAlerter/GeneralWarningBanner/GeneralWarningBanner";
import { type IBannerAlertProps } from "commonComponents/utilities/HeaderAlerter/HeaderAlerter.types";

class MFAWarningBannerInternal extends Component<IBannerAlertProps> {
    private handleDismiss = () => {
        BTLocalStorage.set("bt-boolean-btMFAWarningBannerDismissed", true);
    };

    render() {
        const showBanner = !BTLocalStorage.get("bt-boolean-btMFAWarningBannerDismissed");
        return (
            showBanner && (
                <GeneralWarningBanner {...this.props} closable onClose={this.handleDismiss} />
            )
        );
    }
}

const MFAWarningBanner = withErrorBoundary(MFAWarningBannerInternal)(
    "Could not load 2FA Warning Banner",
);

export default MFAWarningBanner;
